import styled from "styled-components";
import { Type, Button } from "@ebscois/react-component-library";

export const StyledHeaderDelimiter = styled(Type)`
  &:before {
    content: "\\2022";
    padding: 0 ${({ theme }) => theme.space.sm};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: none;
  }
`;

export const StyledLink = styled(Button)`
  font-size: ${({ theme }) => theme.font.size.sm};
  font-weight: ${({ theme }) => theme.font.weight.bold};
  padding-bottom: ${({ theme }) => theme.space.sm};
`;
